import {baseApi} from '@/services/api/base-api';

/**
 * RTK Query API for locale operations
 */
export const localeApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * Fetch locale information based on country or zone
     * @param {Object} arg - The argument object
     * @param {string} [arg.country] - The country code
     * @param {string} [arg.zone] - The zone code
     * @returns {Promise<Locale>} - A promise that resolves to the locale data
     */
    getLocale: builder.query({
      query: (arg = {}) => {
        const {country, zone} = arg || {};
        let url = `/locale`;

        if (country) {
          url += `?country=${encodeURIComponent(country)}`;
        } else if (zone) {
          url += `?zone=${encodeURIComponent(zone)}`;
        }

        return url;
      },
      providesTags: (result, error, arg) => [{type: 'Locale', id: arg?.country || arg?.zone || 'base'}],
    }),
  }),
});

export const {useGetLocaleQuery} = localeApi;
